import type { FaireProductEntity } from "../../entity_types/product";

export const p_bmmnp5kzbg: FaireProductEntity = {
  token: "p_bmmnp5kzbg",
  type: "product",
  name: "Snack Plate",
  brandToken: "b_9uq4muepj6",
  brandName: "unit65",
  imageUrl:
    "https://cdn.faire.com/fastly/348fc3bef74fb2bdaf8cac30979a493b6807a7bb51f15ea44737481acf4c7496.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a7ebcb3ef3fc1302438bbca19a5b62371cf6fb04165bfd91c869a28a9279990d.jpeg",
    "https://cdn.faire.com/fastly/3ff077e821f10836b92259c311ad7b1a9d4f32a3f4b5dbae881251da6bbcf80d.jpeg",
    "https://cdn.faire.com/fastly/a18002aedba2379e1bbf679a5ec52c09b0b57bf047fc15cc8010c632b6b03a84.jpeg",
    "https://cdn.faire.com/fastly/e206a37430d40d7f4c53b6416d53853a36da1cfecbd45b937ea5ae508772dbf3.jpeg",
    "https://cdn.faire.com/fastly/b9b68d66232c347353e851367be24a5119c84c36553dbf7d40c70c770d4ad107.png",
    "https://cdn.faire.com/fastly/e0a0a3c94d3694e10416312beb8a55b23a48453079d9bd33edd2f82875ab5e0a.png",
    "https://cdn.faire.com/fastly/5090e9966f488e304a528de92c7aa6f29957ddf8991cee2b8423692c4bdf180c.jpeg",
    "https://cdn.faire.com/fastly/14d6ed18f45a0037a7acf6177a1913de81d8f5ebd3a3d5736d15e7cadb0d82f4.jpeg",
    "https://cdn.faire.com/fastly/be6f325001dc1b304622bee27defef7658e947f562474149b0994901447c9842.jpeg",
    "https://cdn.faire.com/fastly/3a0cc677739bc1091cc5f61326af9229fb763b4db20f6f68a55dd5b4bad59c19.jpeg",
    "https://cdn.faire.com/fastly/12266de641b82b4e145c90d987f9c9a00ef50be172535027175f07ef7683aa42.jpeg",
    "https://cdn.faire.com/fastly/eba3ed63b8e875ad4fb78ecbde5c55ed4b9b60f6e378f06cd7585c9daf967766.jpeg",
    "https://cdn.faire.com/fastly/8bd843c45f8dd67ad496ac09c16abaeb02579498ec0264366442f850175efc92.jpeg",
    "https://cdn.faire.com/fastly/9ce797a43f5dc9294d9a58195dd26579bcf4f845e9f153bfd3f0543e800696fd.jpeg",
    "https://cdn.faire.com/fastly/94084d69a440a298b224d57181eb524a4f5021b2973b98d4eed188625c843135.jpeg",
    "https://cdn.faire.com/fastly/34c8d131ab0796e39a0a607f4051ba9e33306ce6d1e48001574ee9be6b4baf96.jpeg",
    "https://cdn.faire.com/fastly/7919ce9e4e4239b24f775499d1fd8ba54c666c2093e1455fe3801bc3a0fd1c9d.jpeg",
    "https://cdn.faire.com/fastly/61c7ee1e70ee8f9d6b88d6b90f27b571d6299849087699379b7f9e7f4914b648.jpeg",
    "https://cdn.faire.com/fastly/6819b82fdb77992b46fc74c0a1869fabdef2ff67d2e6ccce0c8062c66eb16009.jpeg",
    "https://cdn.faire.com/fastly/020ae377090ad94669e661932356233f6ed38cb8521e952cf3e79cdf16d1b95a.jpeg",
    "https://cdn.faire.com/fastly/0ff1f76616e75d422b484004a8fa36e3d4eec9157f0a4bdde167bff37c0993a9.jpeg",
    "https://cdn.faire.com/fastly/8c1d9f5144009eaac8b1f6b66bf96c878643c9444560727453686263cd694c40.jpeg",
    "https://cdn.faire.com/fastly/1bd9fdf0601c40c2b2a7b80ec8ac75f2577aeb6a2ef5d9cef5d78de97a575b7f.jpeg",
    "https://cdn.faire.com/fastly/5bf00a590d569b5138af079e3e74f67e08a6fcbecdc8c70333575c69359c9b61.jpeg",
    "https://cdn.faire.com/fastly/d069bf4e75c1dc36886802f30a83f078038e0f72b927087f41b2ee4764bed36c.jpeg",
    "https://cdn.faire.com/fastly/4a20ee3c92cb8cacb109f5e5fd180089cb2b47478b6168199c2bb42cde58a694.jpeg",
    "https://cdn.faire.com/fastly/e5927d7ad73869c4ddd5fbb2adf2424f6ea8a73ac652541de125aa3819bc807c.jpeg",
    "https://cdn.faire.com/fastly/a6c42d321f1b06fa8375fe212c3aa356aee5da30ab678308199ff7ae2056b880.png",
    "https://cdn.faire.com/fastly/642e540bb025ca5f1a1b9ce910c5dda71ce7305aeaf28a86745d76c61bd30037.jpeg",
    "https://cdn.faire.com/fastly/673e451f12378347b6615e1e086a00db09ac0f283a35151ac4ccd9669b1d374d.png",
  ],
  priceDollars: 25,
  description:
    'Handmade ceramic snack plate perfect for any hosting needs and everyday home use!\n\nCan be used for fruits, veggies, nuts, charcuterie, crackers, or other snacks. Alternatively, these dishes are great for displaying jewelry on your vanity!\n\nHand formed wells separate the plate into four beautiful sections.\n\nWhether for you or a loved one, these dishes add beauty and simplicity to every home.\n\nColored options are hand formed with a light grey reclaimed stoneware clay and topped with assorted colored glazes. White option is hand formed with white stoneware and topped in a glossy clear glaze.\n\nBack stamped with makers\' mark.\nFood, dishwasher, and microwave safe.\nApprox 6" x 5"\nHandmade with love in LA!',
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:23.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
